/* eslint @typescript-eslint/no-require-imports: 0, @typescript-eslint/no-var-requires: 0*/
import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';

class Footer extends Component {
    render() {
        return (
            <footer className="site-footer">
                <div className="site-main">
                    <div className="d-flex justify-content-between flex-wrap">
                        <div className="links">
                            <NavLink className="link" exact to="/">
                                Home
                            </NavLink>
                            <NavLink className="link" exact to="/platform">
                                Platform
                            </NavLink>
                            <NavLink className="link" exact to="/about">
                                About Us
                            </NavLink>
                            <NavLink className="link" exact to="/disclaimers">
                                Terms & Conditions
                            </NavLink>
                            <NavLink className="link" exact to="/pricing">
                                Pricing
                            </NavLink>
                            <NavLink className="link" exact to="/help">
                                Help
                            </NavLink>
                        </div>
                        <div className="icons">
                            <a href="https://www.facebook.com/tradeupapp/" target="_blank">
                                <img src={require('./images/fb.png').default} alt="facebook-TradeUP" />
                            </a>
                            <a href="https://twitter.com/TradeUP_APP">
                                <img src={require('./images/tw.png').default} alt="twitter-TradeUP" />
                            </a>
                            <a href="https://www.instagram.com/tradeupapp/">
                                <img src={require('./images/in.png').default} alt="instagram-TradeUP" />
                            </a>
                        </div>
                    </div>
                    <p>
                        TradeUP is a trading platform offered by TradeUP Inc. Securities products and brokerage services
                        available through the TradeUP App are offered by TradeUP Securities, Inc.
                    </p>
                    <p>
                        TradeUP Securities, Inc. is a member of <a href="https://www.finra.org/#/">FINRA</a>,{' '}
                        <a href="https://www.sipc.org/">SIPC</a>, and <a href="https://www.nyse.com/index">NYSE</a>, 437
                        Madison Ave, 27th Floor, New York, NY 10022. For further information about TradeUP Securities,
                        Inc., see <a href="https://brokercheck.finra.org/">FINRA BrokerCheck</a>.
                    </p>
                    <hr className="black-line" />
                    <p className="invest-risk">
                        All investments involve risk, including possible loss of principal. The past performance of a
                        security, market, or financial product does not guarantee future results. Electronic trading
                        poses unique risk to investors. System response and access times may vary due to market
                        conditions, system performance, and other factors. Market volatility, volume, and system
                        availability may delay account access and trade executions.
                    </p>
                    <p>
                        $0.00 commission applies to online U.S. equity trades and exchange-traded funds (ETFs) in a
                        TradeUP retail account only for TradeUP Securities, Inc. retail clients. Sell orders are subject
                        to an activity assessment fee. Other exclusions and conditions may apply. See{' '}
                        <a href="https://www.tradeup.com/pricing/commissions-us">
                            https://www.tradeup.com/pricing/commissions-us
                        </a>{' '}
                        for details. Institutional accounts, OTC securities trading and other types of high-touch
                        services are subject to different commission schedules.
                    </p>
                    <p>
                        Margin may not be suitable for all investors due to the risks associated with using leverage.
                        Please review the{' '}
                        <a href="https://www.marsco.com/static/pdf/MARGIN-DISCLOSURE-STATEMENT.pdf">
                            Margin Disclosure Statement
                        </a>{' '}
                        to determine whether a margin account aligns with your investment objectives and risk tolerance.
                    </p>
                    <p>
                        IPOs involve substantial risk and are not appropriate for every investor. Customers should read
                        the offering prospectus carefully and make their own determination of whether an investment in
                        the offering is consistent with their investment objectives, financial situation, and risk
                        tolerance.
                    </p>
                    <p>
                        There are risks associated with short selling, including the risk of unlimited losses and
                        incurrence of margin interest debt. Short selling is not suitable for all investors. Customers
                        should make their own determination of whether a short selling strategy is consistent with their
                        investment objectives, financial situation, and risk tolerance. TradeUP/TradeUP Securities, Inc.
                        does not recommend or endorse the investment of securities that are made available for short
                        sell. Short sell orders can only be placed in a margin account with total account equity of
                        $2000 or above.
                    </p>
                    <p>
                        Options trading entails significant risk and is not appropriate for all investors. Certain
                        complex options strategies carry additional risk. Before trading options, please read{' '}
                        <a href="https://www.theocc.com/Company-Information/Documents-and-Archives/Options-Disclosure-Document">
                            Characteristics and Risks of Standardized Options{' '}
                        </a>
                        . Supporting documentation for any claims, if applicable, will be furnished upon request.
                    </p>
                    <p>
                        No content on the website shall be considered a recommendation or solicitation for the purchase
                        or sale of securities, futures or other investment products. All information and data on the
                        website are for reference only and no historical data shall be considered as the basis for
                        judging future trends.
                    </p>
                    <p>Please read through our Terms and Conditions before investing.</p>
                    <a href="https://static.tradeup.com/files/tradeup-portal/Marsco-Form-CRS.pdf" target="_blank">
                        Customer Relationship Summary
                    </a>
                    <span className="font-weight-bold">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    <a href="https://tigerheadline.com/sec606" target="_blank">
                        SEC RULE 606
                    </a>
                    <span className="font-weight-bold">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    <a
                        href="https://static.tradeup.com/files/tradeup-portal/Extended%20Hours%20Trading%20Risk%20Disclosure.pdf"
                        target="_blank">
                        Extended Hours Trading Risk Disclosure
                    </a>
                    <p className="brand">
                        <Link to="/regb/HUHOO">HUHOO</Link>&nbsp;&nbsp;
                        <Link to="/regb/LAOHU">LAOHU</Link>&nbsp;&nbsp;
                        <Link to="/regb/TRADEUP">TRADEUP</Link>&nbsp;&nbsp;
                        <Link to="/regb/AboutUS">logo</Link>&nbsp;&nbsp;
                        <Link to="/regb/UPFintechTiger">UP Fintech Tiger</Link>&nbsp;&nbsp;
                        <Link to="/regb/AboutHUHOO">AboutHUHOO</Link>&nbsp;&nbsp;
                        <Link to="/regb/TIGERSHARES">TIGERSHARES</Link>
                    </p>

                    <p className="copyright">&copy;2021 TradeUP Securities, Inc. All rights reserved.</p>
                    <a
                        href="https://brokercheck.finra.org/firm/summary/18483"
                        target="_blank"
                        className="btn btn-footer-check">
                        Broker Check
                    </a>
                </div>
            </footer>
        );
    }
}

export default Footer;
